/** Display only: never use the cleaned name to address an authenticated file.
 * Native reply copies use <timestamp>-<index>-<random6>-<original basename>;
 * browser uploads use <timestamp>-<original basename>.
 * Restrict stripping to those storage shapes inside an inbox, not dated filenames
 * elsewhere or external URLs. */
export function assistantFileName(fileRef: string): string {
  let path = fileRef;
  if (/^https?:\/\//i.test(fileRef)) {
    try { path = new URL(fileRef).pathname; } catch { /* Keep the original fallback. */ }
  }
  const basename = path.split("/").pop() ?? path;
  let name = basename;
  if (!/^https?:\/\//i.test(fileRef) && /(?:^|\/)inbox\/[^/]+\/[^/]+$/.test(fileRef)) {
    name = basename.replace(/^\d{13}-\d+-[a-z0-9]{6}-(?=.+)/, "");
    if (name === basename && !/^\d{13}-\d+-/.test(basename))
      name = basename.replace(/^\d{13}-(?=.+)/, "");
  }
  try { return decodeURIComponent(name); }
  catch { return name; }
}
